module.exports = __webpack_public_path__ + "media/application/images/2018/2018-rt-figure-6c50813ea65f0835456ebb007c39bf47.jpg";